module.exports = __webpack_public_path__ + "static/media/emmy.157d852a.svg";